export default __webpack_public_path__ + "static/O0075-909d63bfad6ac93070f5cf53edbda9d5.png";